import {
  AnalyticsEvent,
  EventParameters,
} from "@adsk/acc-issues-core/utils/analytics/analyticsTypes";

export class IssueEditBulkEditDeleteClickEvent implements AnalyticsEvent {
  name = "issue.edit.bulk_edit.delete.click";
  parameters: EventParameters;

  constructor(params: { selectedCount: number }) {
    this.parameters = {
      ...params,
    };
  }
}
